import { DIALYSIS_ATTENDANCE_STATUS } from '@/features/fluid/constants/reading';
import { FORM_LIMIT } from '@/shared/constants/forms';
import { FLUID_NOTIFICATION } from '@/features/fluid/constants/notification';

export const attendanceSchema = {
  type: 'object',
  additionalProperties: false,
  required: ['dates', 'status', 'notificationCode', 'questionDate', 'requestId'],
  properties: {
    notificationUnique: { type: 'string', minLength: 1, maxLength: 50 },
    questionDate: { type: 'string', format: 'date' },
    requestId: { type: 'string', minLength: 1, maxLength: 50 },
    dates: {
      type: 'array',
      minItems: 1,
      uniqueItems: true,
      items: { type: 'string', format: 'date' },
    },
    status: { enum: Object.values(DIALYSIS_ATTENDANCE_STATUS) },
    notificationCode: { enum: [FLUID_NOTIFICATION.ATTENDANCE, FLUID_NOTIFICATION.OVERDUE] },
    note: { type: 'string', maxLength: FORM_LIMIT.NOTE },
  },
  allOf: [
    {
      if: {
        properties: {
          notificationCode: { const: FLUID_NOTIFICATION.OVERDUE },
          status: { const: DIALYSIS_ATTENDANCE_STATUS.NO },
        },
      },
      then: {
        required: ['note'],
        properties: {
          note: {
            type: 'string',
            minLength: 1,
            pattern: '\\S',
            errorMessage: {
              minLength: 'shared.validation.required',
              pattern: 'shared.validation.required',
            },
          },
        },
      },
    },
  ],
};
